import { nextTick, watch, onMounted, useTemplateRef } from "vue";
import { useDebugLogger } from "./useDebugLogger.js";
export function useAutoScroll(messages, refName = "scrollContainer", options = {}) {
  const { scrollDelay = 50, smooth = true } = options;
  const scrollContainerRef = useTemplateRef(refName);
  const { log, error } = useDebugLogger();
  function performScroll(container) {
    try {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: smooth ? "smooth" : "instant"
      });
    } catch {
      container.scrollTop = container.scrollHeight;
    }
  }
  function logScrollInfo(container) {
    log("Auto-scroll triggered:", {
      scrollHeight: container.scrollHeight,
      clientHeight: container.clientHeight,
      scrollTop: container.scrollTop,
      messagesCount: messages.value.length
    });
  }
  function scrollToBottom() {
    setTimeout(() => {
      const container = scrollContainerRef.value;
      if (!container) {
        error("Scroll container ref not available");
        return;
      }
      performScroll(container);
      logScrollInfo(container);
    }, scrollDelay);
  }
  function scheduleAutoScroll() {
    nextTick(scrollToBottom);
  }
  function initializeScrollOnMount() {
    if (messages.value.length > 0) {
      nextTick(scrollToBottom);
    }
  }
  watch(messages, scheduleAutoScroll, { deep: true, flush: "post" });
  onMounted(initializeScrollOnMount);
  return {
    scrollContainerRef,
    scrollToBottom
  };
}
